import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPost, doPostDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9015/api'

//สถานะ
export const getLawStatus = (lawType) => {
  const url = `${API_ROOT}/v1/legal/law-status/${lawType}`
  return doGet(url)
}

export const getLawSubStatus = (lawType, lawStatus) => {
  const url = `${API_ROOT}/v1/legal/law-sub-status/${lawType}/${lawStatus}`
  return doGet(url)
}

//บันทึกคดี
export const getLawLists = (lawId) => {
  const url = `${API_ROOT}/v1/legal/litigation/record?id=${lawId}`
  return doGet(url)
}

export const deleteLitigation = (id) => {
  const url = `${API_ROOT}/v1/legal/litigation/record?id=${id}`
  return doDelete(url)
}

export const saveLawLists = (request) => {
  const url = `${API_ROOT}/v1/legal/litigation/record`
  return doPostFiles(url, request)
}

//แสดงรายการงานคดี
export const getLegalReportSearch = (request) => {
  const url = `${API_ROOT}/v1/legal/litigation/report/search`
  return doPost(url, request)
}

export const getLegalReportFile = (request) => {
  const url = `${API_ROOT}/files/download/legal-report`
  return doPostDownload(url, request)
}

//ติดตามคดี
export const GetLawFollowPage = (litigationId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/legal/follow/page?litigationId=${litigationId}`
  return doGet(url)
}

export const getLegalFollow = (id) => {
  const url = `${API_ROOT}/v1/legal/follow/${id}`
  return doGet(url)
}

export const saveLegalFollow = (litigationId, request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/legal/follow/save/${litigationId}`
  return doPostFiles(url, request)
  // return doPost(url, request)
}

export const getLegalFollowPage = (litigationId, pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/legal/follow/history?litigationId=${litigationId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}
export const getLegalFollowHistory = (litigationId, pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/legal/follow/history?litigationId=${litigationId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

//Download file
export const getLitigationFile = (fileId) => {
  const url = `${API_ROOT}/v1/legal/litigation/attachments/download/${fileId}`
  return doDownload(url)
}

export const downloadLitigationFileByPath = (pathFile) => {
  const url = `${API_ROOT}/v1/legal/litigation/file/download?pathFile=${pathFile || ''}`
  return doDownload(url)
}

export const downloadEcontractFile = (econtractId) => {
  const url = `${API_ROOT}/v1/legal/econtract-file/${econtractId}`
  return doDownload(url)
}

export const calculateLegalFollow = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/legal/calculate`
  return doPost(url, request)
}
